import { Assignment, AttachFile } from "@mui/icons-material";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Badge, Button, Grid2, Tooltip } from "@mui/material";
import { ColDef, EditableCallbackParams } from "ag-grid-enterprise";
import React from "react";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";

type Props = {
	showContextMenu: Function;
	allowAttachments?: boolean;
	showAsset?: boolean;
	showShiftCrew?: boolean;
};

export const useTableData = ({
	showContextMenu,
	allowAttachments,
	showAsset,
	showShiftCrew,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "CreateTimestamp",
			headerName: "Created",
			flex: 2,
			valueGetter: (params) =>
				dxtToLocalServerTime(params.data.CreateTimestamp, "MM/dd/yy HH:mm"),
		},

		...(showAsset
			? [
					{
						field: "AssetName",
						headerName: "Asset",
						sortable: true,
						flex: 2,
						minWidth: 70,
						wrapText: true,
						autoHeight: true,
					},
				]
			: []),

		{
			field: "Title",
			headerName: "Title",
			flex: 4,
		},
		{
			field: "Author",
			headerName: "Created By",
			flex: 2,
		},

		// show only if shift-crew is allowed
		...(showShiftCrew
			? [
					{
						field: "Shift",
						headerName: "Shift",
						sortable: false,
						width: 58,
						minWidth: 58,
						maxWidth: 58,
						cellStyle: { textAlign: "center" },
					},
					{
						field: "Crew",
						headerName: "Crew",
						sortable: false,
						width: 58,
						minWidth: 58,
						maxWidth: 58,
						cellStyle: { textAlign: "center" },
					},
				]
			: []),

		{
			field: "WorkOrderCount",
			headerName: "",
			sortable: false,
			width: 42,
			minWidth: 42,
			maxWidth: 42,
			cellRenderer: (params: EditableCallbackParams) => {
				const count = params.data.WorkOrderCount || 0;
				return (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							height: "100%",
						}}
					>
						<Badge
							badgeContent={count}
							color="primary"
							anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
							sx={{ "& .MuiBadge-badge": { bottom: "3px" } }}
							style={{ transform: "scale(0.8)" }}
						>
							<Tooltip title="Work Orders">
								<Assignment
									style={{ color: count > 0 ? "#EAB308" : "#c4c4c4" }}
								/>
							</Tooltip>
						</Badge>
					</div>
				);
			},
		},

		...(allowAttachments
			? [
					{
						field: "AttachmentCount",
						headerName: "",
						sortable: false,
						width: 42,
						minWidth: 42,
						maxWidth: 42,
						cellRenderer: (params: EditableCallbackParams) => {
							const count = params.data.AttachmentCount || 0;
							return (
								<div
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										height: "100%",
									}}
								>
									<Badge
										badgeContent={count}
										color="primary"
										anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
										sx={{ "& .MuiBadge-badge": { bottom: "3px" } }}
										style={{ transform: "scale(0.8)" }}
									>
										<Tooltip title="Attachments">
											<AttachFile
												style={{ color: count > 0 ? "#1976d2" : "#c4c4c4" }}
											/>
										</Tooltip>
									</Badge>
								</div>
							);
						},
					},
				]
			: []),

		{
			field: "Content",
			headerName: "Content",
			hide: true,
		},
		{
			headerName: "",
			flex: 1,
			wrapText: false,
			autoHeight: false,
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid2
						container
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Grid2
							size={{ md: 12, xs: 12 }}
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Button
								fullWidth
								onClick={(e) =>
									showContextMenu(e, params.data, "logbookEntryContext")
								}
								size="small"
							>
								<FormatListBulletedSharpIcon
									style={{ height: "auto" }}
									color="action"
								/>
							</Button>
						</Grid2>
					</Grid2>
				);
			},
		},
	];
	return { columnDefs };
};
